import { DefaultGlobal } from "./global";

import { DefaultGraphicUtil, DefaultTransformUtil } from "./graphic-utils";

import { DefaultLayerService } from "./layer-service";

import { DefaultWindow, VWindow } from "./window";

import { GraphicUtil, LayerService, TransformUtil } from "./constants";

import { EnvContribution, VGlobal } from "../constants";

import { createContributionProvider } from "../common/contribution-provider";

import { TextMeasureContribution } from "./contributions/textMeasure/textMeasure-contribution";

export function bindCoreModules({bind: bind}) {
    bind(VGlobal).toDynamicValue((({container: container}) => new DefaultGlobal(createContributionProvider(EnvContribution, container)))).inSingletonScope(), 
    bind(VWindow).to(DefaultWindow), bind(GraphicUtil).toDynamicValue((({container: container}) => new DefaultGraphicUtil(createContributionProvider(TextMeasureContribution, container)))).inSingletonScope(), 
    bind(TransformUtil).to(DefaultTransformUtil).inSingletonScope(), bind(LayerService).to(DefaultLayerService).inSingletonScope();
}

export default bindCoreModules;
//# sourceMappingURL=core-modules.js.map
